'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_SUBMISSION_FAILED = exports.FORM_SUBMISSION_FAILED = 'FORM_SUBMISSION_FAILED';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/formConstants.js
// module id = 435
// module chunks = 0